<template>
  <f7-page>
    <f7-navbar :sliding="false">
      <f7-nav-left v-if="user && user.id">
        <user-info-item
          :emoji="user.status.image"
          :title="`${user.lastName} ${user.name}`"
          :is-data-load="initialStateLoad"
          :link-text="user.status.name"
          href="/profile"
        ></user-info-item>

        <user-info-item
          emoji="$"
          :title="user.balance"
          :is-data-load="initialStateLoad"
          :link-text="$t('by_more_credits')"
          href="/balance"
        ></user-info-item>

        <!-- <user-info-item
          emoji="⭐️"
          :title="user.coin"
          :is-data-load="initialStateLoad"
        ></user-info-item> -->
        <f7-button
          href="/team"
          color="purple"
          class="custome-round hide-on-lg"
          fill
          large
          round
        >
          Team
        </f7-button>
      </f7-nav-left>
    </f7-navbar>

    <div v-if="lesson.id" class="main-panel-content">
      <lesson-card
        ref="webrtcRef"
        :lesson="lesson"
        :socket-u-r-l="appConfig.video_url"
        :start="lesson.start"
        @finish-lesson="handleFinishLesson"
      ></lesson-card>
    </div>

    <div v-else class="main-panel-content">
      <f7-block v-if="!initialStateLoad" class="center">
        <f7-preloader></f7-preloader>
      </f7-block>

      <f7-swiper
        class="select-slider select-slider--lang margin-top"
        :params="requestState.sliderOption"
      >
        <f7-swiper-slide v-for="language in languages" :key="language.id">
          <f7-button
            fill
            large
            :color="language.id === selectLanguageId ? 'lightblue' : 'white'"
            :class="[
              'select-slider-button',
              {
                'select-slider-button--active': language.id === selectLanguageId
              }
            ]"
            @click="$store.commit('SET_CURRENT_LANGUAGE_ID', language.id)"
          >
            {{ `${language.name} ${language.image}` }}
          </f7-button>
        </f7-swiper-slide>
      </f7-swiper>

      <f7-swiper
        class="select-slider select-slider--rate"
        :params="requestState.sliderOption"
      >
        <f7-swiper-slide v-for="level in levels" :key="level.id">
          <f7-button
            fill
            large
            :href="
              level.isVideo &&
              (permissions.camera !== 'granted' ||
                permissions.microphone !== 'granted')
                ? '/media-permissions'
                : '#'
            "
            :color="level.id === selectLevel ? 'lightblue' : 'white'"
            :class="[
              'select-slider-button',
              {
                'select-slider-button--active': level.id === selectLevel,
                'no-video-permission':
                  level.isVideo &&
                  (permissions.camera !== 'granted' ||
                    permissions.microphone !== 'granted')
              }
            ]"
            @click="
              level.isVideo &&
              (permissions.camera !== 'granted' ||
                permissions.microphone !== 'granted')
                ? null
                : $store.commit('SET_CURRENT_LEVEL_ID', level.id)
            "
          >
            <div class="display-flex align-items-center">
              <div
                class="select-slider-button-image"
                :style="{
                  backgroundImage: `url(${BASE_PATH}${level.image})`
                }"
              ></div>

              <div class="display-flex flex-column align-items-flex-start">
                <div class="select-slider-button-rate-name">
                  {{ level.name }}
                </div>

                <div class="select-slider-button-rate-coast">
                  <b> {{ level.price }}</b>
                  &nbsp;$
                </div>

                <div class="select-slider-button-rate-info">
                  {{ $t(`page_home.minute_lesson`) }}
                </div>
              </div>
            </div>
          </f7-button>
        </f7-swiper-slide>
      </f7-swiper>

      <f7-block v-if="initialStateLoad">
        <f7-button
          class="custome-large"
          fill
          large
          @click="handleCreateRequest"
        >
          {{ $t('page_home.start_learning_now') }}
          <f7-preloader
            v-if="requestState.loading"
            color="white"
          ></f7-preloader>
          <f7-icon v-else f7="arrow_right" color="white" size="24"></f7-icon>
        </f7-button>

        <span v-if="!appConfig.isShowBooking" class="link-with-label">
          <span>{{ $t(`or`) }}</span>
          <f7-link href="/booking">{{ $t(`booking.book_time`) }}</f7-link>
        </span>
      </f7-block>
    </div>

    <!-- Tabs -->
    <f7-segmented
      v-if="secondaryStateLoad && initialStateLoad"
      class="tab-buttons"
    >
      <f7-button tab-link="#tab-history" tab-link-active large>
        {{ $t(`page_lesson_history.title`) }}
      </f7-button>
      <f7-button tab-link="#tab-library" large>
        {{ $t(`page_profile.booking_history`) }}
      </f7-button>
    </f7-segmented>

    <f7-block
      class="scrollable-tab"
      :style="{
        height: `calc(100% - ${
          secondaryStateLoad &&
          initialStateLoad &&
          $$('.scrollable-tab').offset()
            ? $$('.scrollable-tab').offset().top - 26
            : 0
        }px)`
      }"
    >
      <f7-block v-if="!secondaryStateLoad" class="center">
        <f7-preloader></f7-preloader>
      </f7-block>

      <f7-tabs v-else>
        <f7-tab id="tab-history" tab-active>
          <f7-block v-if="!history.length" class="center">
            {{ $t(`not_found`) }}
          </f7-block>

          <f7-list class="history-list" no-hairlines>
            <f7-list-item
              v-for="(lesson, index) in history"
              :key="`${index}${lesson.id}`"
              no-chevron
              :badge="lesson.level"
              :title="lesson.name || 'Undefined'"
              :link="`/lesson-history/${lesson.id}`"
            >
              <span slot="header">
                🕒 &nbsp;
                <b>
                  {{ diff(lesson.end, lesson.start) }}
                </b>
                &nbsp;&nbsp; 📅 &nbsp; {{ prettyDate(lesson.start) }}
              </span>
            </f7-list-item>
          </f7-list>
        </f7-tab>

        <f7-tab id="tab-library">
          <f7-block v-if="!bookingHistory.length" class="center">
            {{ $t(`not_found`) }}
          </f7-block>

          <f7-list v-if="bookingHistory" class="history-list" no-hairlines>
            <f7-list-item
              v-for="(item, index) in bookingHistory"
              :key="`${index}${item.id}`"
              link="#"
              no-chevron
              :title="
                `${$t(`start_in`)} ${format(
                  new Date(item.start),
                  'dd.MM.yyyy HH:mm'
                )}`
              "
            >
              <span slot="header">
                {{
                  `${
                    languages.find((lang) => lang.id === item.languageId).name
                  } · ${levels.find((level) => level.id === item.levelId).name}`
                }}
              </span>
            </f7-list-item>
          </f7-list>
        </f7-tab>
      </f7-tabs>
    </f7-block>
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { format } from 'date-fns';

import { BASE_PATH } from '@/js/const/index.js';
import { prettyDate, diff } from '@/js/helpers/date.js';
import notify from '@/js/helpers/notify.js';

import UserInfoItem from '@/components/UserInfoItem.vue';
import LessonCard from '@/components/LessonCard.vue';

export default {
  name: 'MainPanel',

  components: {
    UserInfoItem,
    LessonCard
  },

  data() {
    return {
      contentHeight: null,
      requestState: {
        sliderOption: {
          slidesPerView: 'auto',
          freeMode: true
        },
        loading: false,
        languageId: 1,
        levelId: 1
      },
      videoChat: {
        isShow: false,
        loading: false,
        roomId: '',
        socketURL: null
      }
    };
  },

  computed: {
    format: () => format,
    BASE_PATH: () => BASE_PATH,
    prettyDate: () => prettyDate,
    diff: () => diff,

    ...mapState({
      appConfig: (state) => state.appConfig,
      permissions: (state) => state.permissions,
      user: (state) => state.user.info,
      bookingHistory: (state) => state.user.bookingHistory,
      initialStateLoad: (state) => state.initialStateLoad,
      secondaryStateLoad: (state) => state.secondaryStateLoad,
      languages: (state) => state.languages,
      levels: (state) => state.levels,
      selectLanguageId: (state) => state.selectLanguageId,
      selectLevel: (state) => state.selectLevel,
      charging: (state) => state.charging,
      history: (state) => state.lesson.history,
      request: (state) => state.request.request,
      lesson: (state) => state.lesson.lesson
    })
  },

  async mounted() {
    // this.$store.subscribe(async mutation => {
    //   switch (mutation.type) {
    //     case 'lesson/SET_LESSON': {
    //       const { id, video } = mutation.payload.lesson;
    //       if (video) {
    //         this.$nextTick(() => {
    //           this.videoChat.roomId = btoa(`reallang_stream_${id}`);
    //           this.videoChat.isShow = true;
    //           setTimeout(() => {
    //             this.$refs.webrtcRef.onJoin();
    //           }, 1000);
    //         });
    //       }
    //       break;
    //     }
    //   }
    // });
    // this.getContentHeight();
  },

  methods: {
    async handleCreateRequest() {
      if (this.user.name && this.user.lastName && this.user.email) {
        this.requestState.loading = true;

        try {
          await this.createRequest({
            languageId: this.selectLanguageId,
            levelId: this.selectLevel
          });

          this.requestState.loading = false;

          this.$f7.views.leftPanel.router.navigate('/search-lesson', {
            clearPreviousHistory: true
          });
        } catch (error) {
          this.requestState.loading = false;
          if (error.customeError && error.customeError.type === 'LOW_BALANCE') {
            notify({ text: 'Low balance' });
          } else {
            notify({ text: this.$t(`notify.something_went_wrong`) });
          }
        }
      } else {
        // Если о юзере нету инфы редирект на страницу редактирования профиля
        notify({ text: 'Fill profile' });
        // this.$f7.views.main.router.navigate('/profile-settings');
      }
    },

    // getContentHeight() {
    //   this.contentHeight = document.querySelector(
    //     '.main-panel-content'
    //   ).clientHeight;
    // },

    handleFinishLesson() {
      this.$f7.views.main.router.navigate('/notification-popup', {
        clearPreviousHistory: true,
        props: {
          icon: 'attention',
          title: this.$t(`notify_popup.leave_chat.title`),
          text: this.$t(`notify_popup.leave_chat.text`),
          mainHandlerText: this.$t(`notify_popup.leave_chat.main_handler_text`),
          secondaryHandlerActionText: this.$t(`return`),
          secondaryHandlerActionType: 'RETURN'
        }
      });
    },

    ...mapActions({
      createRequest: 'request/createRequest'
    })
  }
};
</script>

<style lang="less"></style>
